import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class FlashService {
  constructor(private translateService: TranslateService) {}

  private flashSubject$ = new BehaviorSubject<any>('');

  getMessage(): Observable<string> {
    return this.flashSubject$.asObservable();
  }

  setMessage(msg: string) {
    this.flashSubject$.next(this.translateService.instant(msg));
  }
}

// this.translateService.get(msg).subscribe((msg) => {
//   this.flashSubject$.next(msg);
// });
